import { useMutation, useQueryClient } from '@tanstack/react-query'
import classNames from 'classnames'
import React, { useCallback, useLayoutEffect, useState } from 'react'
import { BiCheck } from 'react-icons/bi'

import { surveysAPI } from '../../../api/services/surveys'
import { Survey } from '../../../api/services/surveys/types.ts'
import { SurveyTemplates } from '../../../api/services/user_assignment_codes/types.ts'

const SurveyCheckbox = ({
  codeAssignment,
  surveyTemplates,
  row,
  toggleNumber
}: {
  codeAssignment: string
  surveyTemplates: SurveyTemplates[]
  row: Survey
  toggleNumber: (value: number | null) => void
}) => {
  const queryClient = useQueryClient()
  const [checked, setChecked] = useState(false)

  useLayoutEffect(() => {
    const results = surveyTemplates.find((item) => item.id === row.id)
    setChecked(results !== undefined)
    toggleNumber(results !== undefined ? results.id : null)
  }, [row])

  const toggleAssignmentCode = async () => {
    try {
      const results = await surveysAPI.toggleCode(row.id, codeAssignment)
      if (results.status === 200) {
        setChecked(!checked)
        toggleNumber(row.id)
      }
    } catch (error) {
      console.log('toggleAssignmentCode error', error)
    }
  }

  const { mutateAsync } = useMutation({
    mutationFn: toggleAssignmentCode,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['assignmentCodes'] })
    }
  })

  const checkboxClass = classNames(
    'relative flex w-6 h-6 border-4 dark:border-gray-700 dark:bg-gray-600 rounded-md justify-center items-center',
    { 'cursor-pointer': true }
  )

  const handleClick = useCallback(async () => {
    await mutateAsync()
  }, [mutateAsync])

  return (
    <div
      className="flex justify-center items-center h-full w-full"
      onClick={handleClick}
    >
      <div className={checkboxClass}>
        {checked && (
          <BiCheck
            className="text-green-500 absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 scale-150"
            size={22}
          />
        )}
      </div>
    </div>
  )
}
export default React.memo(SurveyCheckbox)
